<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                精准供应
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    单品供货商专注于特定商品的供应，能够深入了解该商品的市场需求、生产周期、质量控制等各个环节，从而提供更高质量的产品。
                                    这种专业化供应确保了采购员能够获得符合企业标准的商品。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                降低采购复杂性
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    通过与单品供货商合作，采购员可以减少寻找多个供应商的时间和精力，简化采购流程，专注于质量和价格的谈判。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                标准化产品
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    单品供货商通常能够提供标准化的商品，确保每次采购的产品在质量、规格和包装上都一致。
                                    这对于连锁餐饮企业来说尤为重要，能够确保所有门店的产品质量一致，提升客户体验。

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                定向采购
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    单品供货商可以根据“时鲜管理”系统中的“集中采购”需求，提前准备所需商品，
                                    确保采购员在外出采购时能够快速获取所需的商品，减少等待时间。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                质量追溯
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    由于单品供货商专注于特定商品，企业可以更容易地追溯产品来源，
                                    确保供应链的透明度和可控性，特别是在食品安全方面。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                支持时鲜管理
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    单品供货商的存在，使得企业能够更好地执行“时鲜管理”战略，确保产品的新鲜度和质量，
                                    同时提高供应链的反应速度和灵活性。

                                </p>
                            </div>
                        </div>
                    </div>
                </div>




            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "GOODS_two_column_text"
    }
</script>

<style lang="less">


</style>